<template>
	<hr :class="classes" />
</template>

<script>
export default {
	props: {
		type: String
	},
	computed: {
		classes() {
			return [`line-${this.type}`]
		}
	}
}
</script>

<style>
.line-primary {
	border-top: 2px solid #2196f3;
}
</style>
